import { ComponentMessagesVO } from '@repo/types'
import { GenericAbortSignal } from 'axios'
import { fetcher } from '../utils'

export default async (
  sessionId: number,
  page: number = 0,
  signal: GenericAbortSignal
): Promise<ComponentMessagesVO> => {
  return fetcher(`/api/chats/${sessionId}/messages?page=${page}&offset=20`, 'GET', undefined, undefined, signal)
}
